import * as Sentry from "@sentry/react";
import { sentryEventLimit } from "grewe-libs/src/lib/sentryEventLimit.ts";
import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router";

import { envFromHostname } from "~lib/envHelpers.ts";
import { whenFirstPainted } from "~lib/firstPaint.ts";

import { config } from "./config.ts";

export function init() {
  const env = envFromHostname();

  if (config().sentryDsn) {
    Sentry.init({
      dsn: config().sentryDsn,
      integrations: [
        Sentry.reactRouterBrowserTracingIntegration({
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
      ],
      environment: env,
      release: `grewe-gruppe-app@${config().gitSha}`,
      tracesSampleRate: Number(config().sentrySampleRate) || 0.0,
      // 0 + 1.0 = buffer replays in memory and upload only when an error occurs
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,
      beforeSend: sentryEventLimit(env),
      // debug: true,
    });
    Sentry.setContext("git", {
      sha: config().gitSha || "unknown",
    });
    // Replay is 125 KB of the start graph; errors before the first paint go out without a replay
    whenFirstPainted()
      .then(() => import("./sentryReplay.ts"))
      .then((lazy) => Sentry.addIntegration(lazy.replayIntegration()))
      .catch((error) => Sentry.captureException(error));
  }
}
